import Vue from 'vue'

export default {
  get (id, config = {}) {
    return Vue.http.get(`/slotting/reports/${id}`, {
      ...config
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/slotting/report.js